<div class="container pt-3 pb-3">
  <div class="row">
    <div class="col-md-4">
      <div class="row">
        <div class="col"><img [src]="logoService.logoSource" alt="logo"></div>
      </div>

      <div class="row">
        <div class="col">
          <h1>VIDEX</h1>
        </div>
      </div>

    </div>

    <div class="col-md-8">
      <div class="row">
        <div class="col"><img src="assets/headerbild_videx_small.jpg" alt="headerbild_videx_small" width="100%" height="100%"></div>
      </div>
    </div>
  </div>

  <h2 i18n="@@impressum" class="mt-5">Impressum</h2>

  <h3 i18n>Das Internetangebot des Auswärtigen Amts wird herausgegeben von</h3>

  <p><span i18n>Auswärtiges Amt</span><br>
    <span i18n>Werderscher Markt 1</span><br>
    <span i18n>10117 Berlin</span><br>
    <span i18n>Postanschrift: 11013 Berlin</span></p>

  <table>
    <tbody>
    <tr>
      <td colspan="1" rowspan="1" i18n>Telefon:</td>

      <td colspan="1" rowspan="1" i18n>03018-17-0</td>
    </tr>

    <tr>
      <td colspan="1" rowspan="1" class="pr-2" i18n>Bürgerservice:</td>

      <td colspan="1" rowspan="1" i18n>03018-17-2000</td>
    </tr>

    <tr>
      <td colspan="1" rowspan="1" i18n>Telefax:</td>

      <td colspan="1" rowspan="1" i18n>03018-17-3402</td>
    </tr>

    <tr>
      <td colspan="1" rowspan="1" i18n>Website:</td>

      <td colspan="1" rowspan="1" i18n>www.auswaertiges-amt.de</td>
    </tr>

    <tr>
      <td colspan="1" rowspan="1" i18n>E-Mail:</td>

      <td colspan="1" rowspan="1">poststelle&#64;auswaertiges-amt.de</td>
    </tr>
    </tbody>
  </table>

  <h3 i18n>Für Ihre Fragen und Anliegen nutzen Sie bitte das Kontaktformular:</h3>

  <div class="row ms-0" [ngSwitch]="currentLang">
    <a *ngSwitchCase="'de'"
       title="Kontakt"
       href="https://diplo.de/Kontakt" target="_blank"
       rel="noreferrer noopener"
       i18n>Kontaktformular</a>
    <a *ngSwitchDefault
       title="Kontakt"
       href="https://diplo.de/contact" target="_blank"
       i18n>Kontaktformular</a>
  </div>

  <h3 i18n>Bildmaterial:</h3>

  <p>Auswärtiges Amt<br>
    dpa / picture alliance<br>
    photothek<br>
    Colourbox<br>
    BPA<br>
    pixelio</p>

  <h3 i18n>Gestaltung und technische Umsetzung:</h3>

  <p>
    <a href="https://www.conet-isb.de/" title="Externer Link&amp;nbsp;www.conet-isb.de" target="_blank" rel="noreferrer noopener">www.conet-isb.de</a><br>
    <span
      i18n>[Hinweis: nutzen Sie diesen Link bitte NICHT zur Kontaktaufnahme mit dem Auswärtigen Amt, sondern stattdessen unser Kontaktformular.]</span>
  </p>

  <h2 i18n>Rechtliche Hinweise</h2>

  <h3 i18n>Urheberrecht</h3>

  <p i18n>
    Die Inhalte, insbesondere Texte, Bildmaterial und alle Multimediaelemente und -inhalte auf der Website des Auswärtigen Amts sind urheberrechtlich
    geschützt. Alle Rechte vorbehalten.</p>

  <p i18n>
    Wenn Sie Texte aus dem Bereich der Länderinformationen (Reise- und Sicherheitshinweise, allgemeine Länderinformationen etc.) in Ihre Website
    integrieren wollen, so tun Sie dies bitte per Link auf unsere Website und nicht durch eine physische Übernahme der Texte. Unsere Informationen
    werden laufend der aktuellen Situation angepasst, und nur durch eine Verlinkung können Sie sicher sein, stets auf die aktuellen Informationen zu
    verweisen.</p>

  <p i18n>
    Wir achten sorgfältig auf die Richtigkeit, Aktualität, Vollständigkeit und Verständlichkeit der hier veröffentlichten Inhalte. Dennoch gilt
    Folgendes:</p>

  <h3 i18n>Inhalte anderweitiger Anbieter</h3>

  <p i18n>
    Die Links zu Inhalten von Internet-Seiten Dritter („fremden Inhalten“) wurden nach bestem Wissen und unter Beachtung größtmöglicher Sorgfalt
    erstellt, es wird jedoch keine Gewähr für deren Vollständigkeit und Richtigkeit übernommen. Das Auswärtige Amt hat keinerlei Einfluss auf die
    aktuelle und zukünftige Gestaltung und auf die Inhalte von per Link verknüpften Seiten. Aus diesem Grund übernehmen wir keinerlei Verantwortung
    für solche fremden Inhalte.</p>

  <p i18n>Dies gilt auch für Inhalte Dritter, die technisch in die Webseite des Auswärtigen Amts integriert und als solche gekennzeichnet sind.</p>

  <h3 i18n>Eigene Inhalte</h3>

  <p i18n>
    Für die Vollständigkeit und Richtigkeit der Eintragungen wird keine Haftung übernommen. Etwaige rechtliche Hinweise, Empfehlungen und Auskünfte
    sind unverbindlich; eine Rechtsberatung findet nicht statt.</p>

  <h3 i18n>Rückmeldung</h3>

  <p i18n>
    Falls das Auswärtige Amt auf Seiten verweist, deren Inhalt Anlass zur Beanstandung gibt, bittet die Internet-Redaktion um Mitteilung. Teilen Sie
    uns bitte ebenso mit, wenn eigene Inhalte nicht fehlerfrei, aktuell, vollständig oder verständlich geschrieben sind.</p>

  <h3 i18n>Steuernummer</h3>

  <p i18n>Die Umsatzsteuer-ID des Auswärtigen Amts lautet: DE122118920</p>

  <p i18n>Ihre Internetredaktion</p>
</div>
